import { commonService } from '.';

const getAll = () => {
  return commonService.get('Lang/all');
};

const getById = (id) => {
  return commonService.getWithParam('Lang/getById?id=' + id, null);
};

const changeUserLang = (idUser, idLang) => {
  return commonService.put('Lang/changeUserLang?idUser=' + idUser + '&idLang=' + idLang, null);
};

export const langService = {
  getAll,
  getById,
  changeUserLang
};
